<template>
  <div class="licenseHistory">
    <el-form :inline="true" :model="licenseHistoryNumForm" ref="licenseHistoryNumForm" :rules="searchRules" class="demo-form-inline">
      <h1>License History</h1>
      <el-form-item prop="option">
      <el-cascader v-model="licenseHistoryNumForm.option" :options="options" ref="eventCascader" @change="elCascaderOnlick" :show-all-levels="false" placeholder="Select Event Type"></el-cascader>
      </el-form-item>
      <el-form-item prop="number">
        <el-input v-model="licenseHistoryNumForm.number" v-show="showOuterLicenseInput" @keyup.enter.native="onSubmit" :placeholder="licenseHistoryInputPlaceHolder"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" plain v-show="showOuterLicenseInput" @click="onSubmit" :loading="searching">Search</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          class="upload-license" v-show="showLicenseUpload" ref="upload"
          drag action="uploadLicenceRequest" :multiple="false" :limit="1"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :on-exceed="handleUploadExceed"
          :http-request="uploadLicenceRequest">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drag file to here or <em>Click to upload file</em></div>
          <div class="el-upload__tip" slot="tip">Please upload the .lic file</div>
        </el-upload>
      </el-form-item>
      <el-form-item style="float: right; color:red" v-show="showLicenseHistoryRecord">
        *Deleted Record will be highlighted
      </el-form-item>
    </el-form>

    <el-table ref="filterTable" :data="licenseHistoryData" v-show="showLicenseHistoryRecord" v-loading="searching" style="width: 100%"
              :row-class-name="tableRowClassName"
              :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}" :cell-style="{textAlign: 'center'}">
<!--      <el-table-column prop="deleted" label="Deleted"></el-table-column>-->
      <el-table-column prop="er_num" label="ER Number" min-width="95" sortable :sort-orders="['ascending', 'descending']" :formatter="arrayFormat"></el-table-column>
      <el-table-column prop="content.outerlicense" label="Outer License ID" min-width="95" sortable :sort-orders="['ascending', 'descending']"></el-table-column>
      <el-table-column prop="content.interlicense" label="Inter License ID" min-width="90" sortable :sort-orders="['ascending', 'descending']"></el-table-column>
      <el-table-column prop="content.project" label="Project Name" min-width="90" sortable :sort-orders="['ascending', 'descending']"></el-table-column>
      <el-table-column prop="timestamp" label="Timestamp [as UTC(+00:00)]" :formatter="dateFormat"></el-table-column>
      <el-table-column prop="content.direct_cus" label="Direct Customer"></el-table-column>
      <el-table-column prop="content.ne_point" label="Ne Point"></el-table-column>
      <el-table-column prop="content.exp_date" label="Expiry Date [as UTC(+00:00)]" :formatter="contentDateFormat"></el-table-column>
      <el-table-column prop="content.license_content" label="License Content" :formatter="jsonFormat"></el-table-column>
      <el-table-column prop="content.user_email" label="Customer Email"></el-table-column>
    </el-table>

    <el-pagination
      v-show="showLicenseHistoryRecord"
      @current-change="handleCurrentChange"
      :current-page=curPage
      layout="total, prev, pager, next, jumper"
      :total=numOfData>
    </el-pagination>

<!--    <el-table :data="snapshotData" v-show="showSnapshotRecord" style="width: 100%">
      <el-table-column v-for="(item,key) in titleData" :key="key" :prop="item.value"
                       :label="item.name"></el-table-column>
    </el-table>-->

  </div>
</template>

<script>
import {
  searchLicenseHistoryByPage,
  searchLicenseHistory,
  searchLicenseHistoryByFile,
  searchLicenseHistoryByFileByPage,
  getLicenseHistoryList
} from '../api'
import moment from 'moment'
export default {
  name: 'LicenseHistory',
  data () {
    return {
      searching: false,
      showLicenseHistoryRecord: false,
      showLicenseUpload: false,
      showOuterLicenseInput: true,
      licenseHistoryInputPlaceHolder: 'Outer License ID',
      license_file: null,
      search_type: '',
      licenseHistoryData: [],
      // Header data
      titleData: [],
      licenseHistoryNumForm: {
        number: '',
        option: ''
      },
      searchRules: {
        number: [
          { required: true, message: 'Please Enter the Search Query', trigger: 'blur' }
        ],
        option: [
          { type: 'array', required: true, message: 'Please Select a License Type', trigger: 'blur' }
        ]
      },
      options: [{
        value: 'license_id',
        label: 'Outer License'
      }, {
        value: 'er_num',
        label: 'ER Number'
      }, {
        value: 'license_file',
        label: 'License File'
      }],
      eventCascader: null,
      numOfData: 0,
      numOfPage: 0,
      curPage: 1
    }
  },
  mounted () {

  },
  created: function () {
    this.searching = false
    this.showLicenseHistoryRecord = false
    this.showLicenseUpload = false
    this.showOuterLicenseInput = true
    this.getDataList()
  },
  watch: {
    search_type: function () {
      if (this.search_type === 'er_num') {
        this.licenseHistoryInputPlaceHolder = 'ER number'
      } else {
        this.licenseHistoryInputPlaceHolder = 'Outer License ID'
      }
    }
  },
  methods: {
    getDataList () {
      let that = this
      that.searching = true
      getLicenseHistoryList().then(data => {
        console.log('getLicenseHistoryList Succeed')
        console.log(data)

        that.licenseHistoryData = data.license_record
        that.showLicenseHistoryRecord = true

        console.log('getLicenseHistoryList Success -> that.licenseHistoryData')
        console.log(that.licenseHistoryData)

        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = 1
        that.showLicenseRecord = true
        that.searching = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
        that.licenseHistoryData = []
        that.numOfData = 0
        that.numOfPage = 0
        that.curPage = 1
      })
    },
    onSubmit () {
      let that = this
      that.$refs.licenseHistoryNumForm.validate((valid) => {
        if (valid) {
          that.searching = true
          searchLicenseHistory(that.search_type, that.licenseHistoryNumForm.number).then(data => {
            that.searching = false
            // that.licenseHistoryData = data;
            that.licenseHistoryData = data.license_record
            that.showLicenseHistoryRecord = true
            that.numOfData = data.count
            that.numOfPage = data.pagecount
            that.curPage = 1

            console.log('searchlicenseHistoryList Success -> that.licenseHistoryData')
            console.log(that.licenseHistoryData)

            if (that.search_type === 'er_num') {
              that.sortByOuterLicense()
            } else {
              that.sortByER()
            }
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.searching = false
            that.licenseHistoryData = []
            that.numOfData = 0
            that.numOfPage = 0
            that.curPage = 1
          })
        } else {
          console.log('error searching!!')
          return false
        }
      })
    },
    elCascaderOnlick (value) {
      let that = this

      console.log('elCascaderOnlick - value = ', value)
      console.log(that.$refs['eventCascader'].getCheckedNodes()[0].label)
      console.log(that.$refs['eventCascader'].getCheckedNodes()[0].value)

      that.search_type = value[0]
      that.showLicenseUpload = value[0] === 'license_file'
      that.showOuterLicenseInput = !that.showLicenseUpload
    },
    handleCurrentChange (val) {
      let that = this
      if (that.search_type === 'license_file') {
        that.uploadLicenceRequestByPage(that.license_file, val)
      } else {
        that.searching = true
        searchLicenseHistoryByPage(that.search_type, that.licenseHistoryNumForm.number, val).then(data => {
          console.log('searchLicenseHistoryByPage Succeed')
          console.log(data)

          that.licenseHistoryData = data.license_record
          that.numOfData = data.count
          that.numOfPage = data.pagecount
          that.curPage = val
          that.showLicenseHistoryRecord = true
          that.showLicenseUpload = false
          that.showOuterLicenseInput = true
          that.searching = false
        }).catch(error => {
          if (error) {
            console.log(error.stack)
          }
          that.searching = false
        })
      }
    },
    handleUploadSuccess (res) {
      this.$notify({
        title: 'Success',
        message: 'Upload File Successfully',
        type: 'success'
      })
    },
    handleUploadError (err) {
      this.$notify({
        title: 'Error',
        message: 'Upload File Failed',
        type: 'error'
      })
      if (err) {
        console.log(err)
      }
    },
    handleUploadExceed (err) {
      this.$notify({
        title: 'Error',
        message: 'Number of Upload File Exceed Limit',
        type: 'error'
      })
      if (err) {
        console.log(err)
      }
    },
    uploadLicenceRequest (params) {
      let that = this
      console.log('uploadLicenceRequest - params')
      console.log(params)

      that.license_file = params.file
      that.searching = true
      that.$refs.upload.clearFiles()
      searchLicenseHistoryByFile(params.file).then(data => {
        console.log('searchLicenseHistoryByFile Succeed')
        console.log(data.license_record)
        that.licenseHistoryData = data.license_record
        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = 1
        that.showLicenseHistoryRecord = true
        that.showLicenseUpload = false
        that.showOuterLicenseInput = true
        that.searching = false
        that.licenseHistoryNumForm.number = ''
        that.licenseHistoryNumForm.option = ''
        that.sortByER()
      }).catch(error => {
        if (error) {
          console.log(error.stack)
          that.$message.error('Search Failed. Please check the license file.')
        }
        that.searching = false
        that.licenseHistoryData = []
        that.numOfData = 0
        that.numOfPage = 0
        that.curPage = 1
      })
    },
    uploadLicenceRequestByPage (file, page) {
      let that = this
      console.log('uploadLicenceRequestByPage - file')
      console.log(file)
      console.log('page')
      console.log(page)

      that.searching = true
      searchLicenseHistoryByFileByPage(file, page).then(data => {
        console.log('searchLicenseHistoryByFileByPage Succeed')
        console.log(data.license_record)
        that.licenseHistoryData = data.license_record
        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = page
        that.showLicenseHistoryRecord = true
        that.showLicenseUpload = false
        that.showOuterLicenseInput = true
        that.searching = false
        that.licenseHistoryNumForm.number = ''
        that.licenseHistoryNumForm.option = ''
        that.sortByER()
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
        that.licenseHistoryData = []
        that.numOfData = 0
        that.numOfPage = 0
        that.curPage = 1
      })
    },
    sortByOuterLicense () {
      this.$refs.filterTable.sort('content.outerlicense', 'ascending')
    },
    sortByER () {
      this.$refs.filterTable.sort('content.er_num', 'ascending')
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      let date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return 'Undefined'
      }

      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss', true)
    },
    contentDateFormat: function (row, column) {
      // Expected prop to be content.xxx
      let date = row[column.property.split('.')[0]][column.property.split('.')[1]]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return 'Undefined'
      }

      return moment.utc(date).format('YYYY-MMM-DD', true)
    },
    jsonFormat: function (row, column, cellValue, index) {
      var jsonObj = cellValue
      if (jsonObj === undefined) {
        return ''
      }
      const jsonStr = JSON.stringify(jsonObj)
      return jsonStr
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    },
    tableRowClassName ({row, rowIndex}) {
      if (row['deleted'] === 'true') {
        return 'deleted-row'
      }
      return ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .generate{
    margin: 0px auto;
    position: relative;
    margin-top: 50px;
  }
</style>

<style>
.el-table .deleted-row {
  background-color: rgba(15, 15, 166, 0.1)
  /*color: rgba(20, 20, 20, 0.3)*/
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: transparent !important;
}

.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// LicenseHistory.vue?5c4fc15f